import { IObservable, SeenTracker, Subject } from '~/rage/utils';
import { IClientConfigs, VehicleConsumableGroup } from '~/shared';
import { IVehicleServiceStationService } from './vehicleServiceStationServiceTypes';

export class VehicleServiceStationServiceStub
	implements IVehicleServiceStationService
{
	private readonly consumables = new Subject<
		IClientConfigs['vehicleWear']['consumables']
	>([
		{
			id: 'motor_oil_0',
			group: VehicleConsumableGroup.MOTOR_OIL,
			name: 'luqoil',
			price: 100,
			resourceKm: 1000,
		},
		{
			id: 'motor_oil_1',
			group: VehicleConsumableGroup.MOTOR_OIL,
			name: 'mobil',
			price: 200,
			resourceKm: 1000,
		},
		{
			id: 'transmission_oil_0',
			group: VehicleConsumableGroup.TRANSMISSION_OIL,
			name: 'luqoil2',
			price: 300,
			resourceKm: 1000,
		},
		{
			id: 'brake_pads_0',
			group: VehicleConsumableGroup.BRAKE_PADS,
			name: 'mobil2',
			price: 400,
			resourceKm: 1000,
		},
		{
			id: 'brake_pads_1',
			group: VehicleConsumableGroup.BRAKE_PADS,
			name: 'brembo',
			price: 100,
			resourceKm: 1000,
		},
		{
			id: 'tires_0',
			group: VehicleConsumableGroup.TIRES,
			name: 'continental',
			price: 300,
			resourceKm: 1000,
		},
		{
			id: 'tires_1',
			group: VehicleConsumableGroup.TIRES,
			name: 'michlein',
			price: 400,
			resourceKm: 1000,
		},
		{
			id: 'tires_2',
			group: VehicleConsumableGroup.TIRES,
			name: 'kama',
			price: 500,
			resourceKm: 1000,
		},
	]);
	private seenTracker = new SeenTracker(null);

	// @TODO
	private readonly engineHealth = new Subject<number>(40);

	// @TODO
	private readonly consumablesHealth = new Subject<
		Partial<Record<VehicleConsumableGroup, number>>
	>({
		[VehicleConsumableGroup.MOTOR_OIL]: 50,
		[VehicleConsumableGroup.TRANSMISSION_OIL]: 50,
		[VehicleConsumableGroup.BRAKE_PADS]: 50,
		[VehicleConsumableGroup.TIRES]: 50,
	});

	private readonly engineRepairPrice = new Subject(20_000);

	public getConsumables(): IObservable<
		IClientConfigs['vehicleWear']['consumables']
	> {
		return this.consumables;
	}

	public getEngineHealth(): IObservable<number> {
		return this.engineHealth;
	}

	public getConsumablesHealth(): IObservable<
		Partial<Record<VehicleConsumableGroup, number>>
	> {
		return this.consumablesHealth;
	}

	public getEngineRepairPrice(): IObservable<number> {
		return this.engineRepairPrice;
	}

	public async buyConsumable(consumableId: string): Promise<void> {
		console.log('VehicleServiceStation:buyConsumable', { consumableId });

		const consumable = this.consumables
			.getValue()
			.find((item) => item.id === consumableId);

		if (!consumable) {
			return;
		}

		const current = this.consumablesHealth.getValue();
		this.consumablesHealth.next({
			...current,
			[consumable.group]: 100,
		});
	}

	public async repairEngine(): Promise<void> {
		console.log('VehicleServiceStation:repairEngine');
		this.engineHealth.next(100);
	}

	public isUnseen(path: string): boolean {
		return this.seenTracker.isUnseen(path);
	}

	public markSeen(path: string): void {
		console.log('vehicleServiceStation:markSeen', path);
		this.seenTracker.markAsSeen(path);
	}

	public async exitMenu(): Promise<void> {
		console.log('VehicleServiceStation:exitMenu');
	}
}
